import { createFileRoute } from "@tanstack/react-router";
import { ChatImportPage } from "@/features/chat-import/ChatImportPage";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/chat-import")({
  beforeLoad: requireAuth,
  component: ChatImportPage,
});
